import { CircularProgress } from '@mui/material';
import _ from 'lodash';
import { TitledPage } from '@client/new/components/Misc';
import { AsyncRenderer } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import {
  LivestreamViewModel,
  useLivestreamViewModel,
} from './useLivestream.viewModel';
import auth from '@client/components/auth';
import { LiveStream } from './LiveStream';
import { EnableLivestream } from './EnableLivestream';

type LiveStreamPageProps = {
  params: {
    influencerId: string;
  };
};

export const LiveStreamPage = (props: LiveStreamPageProps) => {
  const influencerId = props.params.influencerId
    ? parseInt(props.params.influencerId)
    : auth.getUser().influencerId;
  const viewModel = useLivestreamViewModel({ influencerId });

  return (
    <AsyncRenderer
      data={viewModel}
      loadRender={
        <TitledPage title="Livestreaming">
          <div className="flex justify-center items-center">
            <CircularProgress />
          </div>
        </TitledPage>
      }
      renderer={(data) => (
        <TitledPage title="Livestreaming">
          <LivestreamContent {...data} />
        </TitledPage>
      )}
    />
  );
};

const LivestreamContent = (p: LivestreamViewModel) => {
  switch (p.isLivestreamEnabled) {
    case true:
      return <LiveStream influencerId={p.influencerId} />;
    case false:
      return <EnableLivestream {...p} />;
  }
};
